



































import Vue from "vue";
import SignUpForm from "@/components/organisms/SignUpForm.vue";
import TextField from "@/components/molecules/TextField.vue";
import { Auth, API } from "aws-amplify";
import { showNotifyDialog } from "@/lib/dialog";

export default Vue.extend({
  components: { SignUpForm, TextField },
  data() {
    return {
      oldMailAddress: "",
      newMailAddress: "",
      message: "",
      processing: false,
    };
  },
  async created() {
    const cognitoUser = await Auth.currentUserPoolUser();
    this.oldMailAddress = cognitoUser.username;
  },
  methods: {
    async submit() {
      this.processing = true;

      const { oldMailAddress, newMailAddress } = this;
      let userId, cognitoId;

      // verify email
      if (!newMailAddress.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/)) {
        this.message = "メールアドレスの形式が正しくありません。";
        return;
      }

      try {
        const cognitoUser = await Auth.currentUserPoolUser();
        if (cognitoUser) {
          userId = cognitoUser.attributes.sub;
        }
        const cognitoIdentityCredentials = (await Auth.currentCredentials()) as any;
        if (cognitoIdentityCredentials) {
          cognitoId = cognitoIdentityCredentials.data.IdentityId;
        }

        await API.post("Rest", "/mail/verificationlink", {
          body: {
            userId,
            cognitoId,
            newMailAddress,
            oldMailAddress,
          },
        });

        this.message = "";
        await showNotifyDialog({ content: "新しいメールアドレスに本人確認のメールを送りました。" });
        this.$router.push({ name: "myPage" });
      } catch (error: any) {
        console.log({ error });
        this.message = error.response.data.handledMessage || error;
      } finally {
        this.processing = false;
      }
    },
  },
});
